import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import { Button } from '../Button/Button';

export type ConfirmationDialogProps = {
  open: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  title: string;
  message?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  disableBackdropClose?: boolean;
};

export const ConfirmationDialog = ({
  open,
  handleCancel,
  handleConfirm,
  title,
  message,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  disableBackdropClose = false,
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (disableBackdropClose && reason) {
          return;
        }
        handleCancel();
      }}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      data-testid="dialog"
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      {message ? (
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">{message}</DialogContentText>
        </DialogContent>
      ) : null}
      <DialogActions>
        <Button onClick={handleCancel} variant="secondary">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
